import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import { IntakeSectionHeader } from "@/common/styles";
import { Col, Row } from "antd";
import { FormContainer } from "../InmateDetails/styles";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import {
  getOptionsFromRefList,
  isNonEmptyVariable,
} from "@/util/common_function";
import { useSelector } from "react-redux";

const OriginalChargeInformation = ({ originalChargeDescriptionID }) => {
  const checkCount = (_, value) => {
    if (value > 0 && value <= 10000) {
      return Promise.resolve();
    }
    return Promise.reject(
      new Error("Count must be greater than 0 and less than 10000")
    );
  };
  const fullSearch = useSelector(state => state.fullSearch);
  return (
    <>
      <IntakeSectionHeader>
        <span>Original Charge Information</span>
      </IntakeSectionHeader>
      <FormContainer>
        <Row gutter={16}>
          <Col span={18}>
            <FormItem
              name="originalChargeDescriptionID"
              label="Charge"
              layout="vertical"
            >
              <Select
                options={getOptionsFromRefList("Charges", false, false, true)}
                placeholder="Charge"
                showSearch
                variant="outlined"
                isSelectedValueFocus
              />
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem name="originalUCRCode" label="Code" layout="vertical">
              <TextField disabled />
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem
              name="originalChargeLevelID"
              label="Level"
              layout="vertical"
            >
              <Select
                options={getOptionsFromRefList(
                  "Charge_Level",
                  false,
                  false,
                  true
                )}
                placeholder="Level"
                showSearch={false}
                variant="outlined"
              />
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem
              name="originalChargeCount"
              label="Count"
              layout="vertical"
              rules={ !fullSearch ?
                (isNonEmptyVariable(originalChargeDescriptionID)
                  ? [
                      {
                        validator: checkCount,
                      },
                    ]
                  : null) : null
              }
            >
              <TextField type="number" />
            </FormItem>
          </Col>
        </Row>
        <IntakeSectionHeader>
          <span>Agency-Specific Information</span>
        </IntakeSectionHeader>
        <Row gutter={16}>
          <Col span={8}>
            <FormItem label="Legacy Offense" layout="vertical">
              <TextField />
            </FormItem>
          </Col>
          <Col span={8}>
            <FormItem label="Bail Set By" layout="vertical">
              <TextField />
            </FormItem>
          </Col>
          <Col span={8}>
            <FormItem label="Bail Set Date" layout="vertical">
              <TextField />
            </FormItem>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={8}>
            <FormItem label="Indictment Number" layout="vertical">
              <TextField />
            </FormItem>
          </Col>
          <Col span={8}>
            <FormItem label="Responsible Investigator Name" layout="vertical">
              <TextField />
            </FormItem>
          </Col>
          <Col span={8}>
            <FormItem label="Responsible Investigator Phone" layout="vertical">
              <TextField />
            </FormItem>
          </Col>
        </Row>
      </FormContainer>
    </>
  );
};

export default OriginalChargeInformation;
